<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Indoor Air Quality</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (airFilterSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Air Filter:</label>
            <select class="halfWidthInputField" #airFilterInput
              [class.invalidConfigurationSelection]="isInvalidSelection(airFilterSelection.Name)"
              (change)="selectionChanged(airFilterSelection, airFilterInput.value)"
              [value]="airFilterSelection.Value.toString()">
              @for (allowable of airFilterSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="airFilterSelection.Value && airFilterSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (airPurificationSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Air Purification:</label>
            <select class="halfWidthInputField" #airPurificationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(airPurificationSelection.Name)"
              (change)="selectionChanged(airPurificationSelection, airPurificationInput.value)"
              [value]="airPurificationSelection.Value.toString()">
              @for (allowable of airPurificationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="airPurificationSelection.Value && airPurificationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      @if (sideFilterAccessSelection) {
        <div class="configurationDetailRow">
          <span class="halfWidthConfigurationInput"></span>
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(sideFilterAccessSelection.Name)"
            for="sideFilterAccessInput" class="halfWidthInputLabel">{{ sideFilterAccessLabel() }}:</label>
            <input type="checkbox" class="checkboxInput" id="sideFilterAccessInput"
              #sideFilterAccessInput [checked]="'true' === sideFilterAccessSelection.Value"
              (change)="selectionChanged(sideFilterAccessSelection, sideFilterAccessInput.checked.toString())">
          </span>
        </div>
      }
      <div class="configurationDetailRow">
        @if (vocSensorSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">VOC Sensor:</label>
            <select class="halfWidthInputField" #vocSensorInput
              [class.invalidConfigurationSelection]="isInvalidSelection(vocSensorSelection.Name)"
              (change)="selectionChanged(vocSensorSelection, vocSensorInput.value)"
              [value]="vocSensorSelection.Value.toString()">
              @for (allowable of vocSensorSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="vocSensorSelection.Value && vocSensorSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (particulateMatterSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Particulate Matter Sensor:</label>
            <select class="halfWidthInputField" #particulateMatterSensorInput
              [class.invalidConfigurationSelection]="isInvalidSelection(particulateMatterSelection.Name)"
              (change)="selectionChanged(particulateMatterSelection, particulateMatterSensorInput.value)"
              [value]="particulateMatterSelection.Value.toString()">
              @for (allowable of particulateMatterSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="particulateMatterSelection.Value && particulateMatterSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
    </div>
  }
</div>
